import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const SplashLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral950};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._32};
  justify-content: center;
  align-items: center;
`;
